<template>
  <!-- <div class="box"> -->
  <div class="swiper-box">
    <div class="header">
      <div class="btn" :class="type_list.length > 1 ? 'btn-can-hover' : ''">
        <span class="title">{{ title }}</span>
        <div v-if="type_list.length > 1" class="select-box">
          <div class="li-content">
            <li
              v-for="(item, key) in type_list"
              :key="key"
              :name="key"
              :class="key === localIndex ? 'li-select' : ''"
              @click="clickType(key)"
            >
              {{ item.name }}
            </li>
          </div>
        </div>
      </div>
    </div>
    <!-- Swiper -->
    <div class="content swiper" :class="name">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, key) in type_list[localIndex].swiper_list"
          :key="key"
          :name="key"
        >
          <a v-if="item.link" :href="item.link" target="_blank">
            <img :src="item.img" alt="" />
          </a>
          <img v-else :src="item.img" alt="" />
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div
      class="swiper-pagination"
      :class="name + '-swiper-pagination'"
      slot="pagination"
    ></div>
    <div id="swiper-footer" class="footer">
      <div
        class="left"
        :class="slideItem && slideItem.introduce ? 'center' : ''"
      >
        <div v-if="slideItem && slideItem.name" class="name">
          {{ slideItem.name }}
        </div>
        <div
          v-if="
            slideItem.types.split(',').length > 0 &&
            slideItem.types.split(',')[0].length > 0
          "
          class="type"
        >
          <span
            class="item"
            v-for="(item, key) in slideItem.types.split(',')"
            :key="key"
            :name="key"
            >{{ item }}
          </span>
        </div>
        <div v-if="slideItem && slideItem.introduce" class="introduce">
          {{ slideItem.introduce }}
        </div>
      </div>
      <div v-if="slideItem && slideItem.label" class="label">
        {{ slideItem.label }}
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  name: "SwiperBox",
  props: {
    name: {
      type: String,
      default() {
        return "mySwiper";
      },
    },
    title: {
      type: String,
      default() {
        return "获奖作品";
      },
    },
    type_list: {
      type: Array,
      default() {
        return [
          // {
          //   name: "最佳创新设计奖",
          //   swiper_list: [
          //     {
          //       introduce: "最佳创新设计奖",
          //       img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
          //     },
          //     {
          //       introduce: "最佳创新设计奖",
          //       img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
          //     },
          //   ],
          // },
          {
            name: "最佳创新设计奖",
            swiper_list: [
              {
                name: "神觉者",
                types: "策略,卡牌,回合制",
                label: "最佳创新设计奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新设计奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
            ],
          },
          {
            name: "最佳创新美术奖",
            swiper_list: [
              {
                name: "神觉者",
                types: "策略,卡牌,回合制",
                label: "最佳创新美术奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新美术奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新美术奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新美术奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
            ],
          },
          {
            name: "最佳创新音乐音效奖",
            swiper_list: [
              {
                name: "神觉者",
                types: "策略,卡牌,回合制",
                label: "最佳创新音乐音效奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新音乐音效奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新音乐音效奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
            ],
          },
          {
            name: "最佳创新中华文化奖",
            swiper_list: [
              {
                name: "神觉者",
                types: "策略,卡牌,回合制",
                label: "最佳创新中华文化奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
              {
                name: "神觉者2",
                types: "策略,卡牌,回合制",
                label: "最佳创新中华文化奖",
                introduce: "",
                img: "https://website.xdcdn.net/poster/1/2thMegaGame/test/zykVsr6M.png",
                link: "https://www.taptap.com/app/216206",
              },
            ],
          },
        ];
      },
    },
  },
  data() {
    return {
      localIndex: 0,
      mySwiper: null,
    };
  },
  computed: {
    slideItem() {
      let index = this.mySwiper ? this.mySwiper.realIndex : 0;
      return this.type_list[this.localIndex].swiper_list[index];
    },
  },
  mounted() {
    this.mySwiper = new Swiper("." + this.name, {
      pagination: {
        el: "." + this.name + "-swiper-pagination",
        clickable: true,
        // type: "fraction",
        // renderFraction: function (currentClass, totalClass) {
        //   return (
        //     '<span class="' +
        //     currentClass +
        //     '"></span>' +
        //     " - " +
        //     '<span class="' +
        //     totalClass +
        //     '"></span>'
        //   );
        // },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  methods: {
    clickType(key) {
      this.localIndex = key;
      this.$nextTick(() => {
        this.mySwiper.updateSlides();
        this.mySwiper.slideTo(0);
        // document.getElementById("swiper-footer").click();
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@function get_vw($size) {
  @return ($size / 700px) * 100vw;
}
@keyframes bounce {
  0%,
  75% {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
  0%,
  80%,
  88%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  85%,
  86% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0) scaleY(1.1);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  93% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0) scaleY(1.05);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  95% {
    -webkit-transform: translateZ(0) scaleY(0.95);
    transform: translateZ(0) scaleY(0.95);
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  98% {
    -webkit-transform: translate3d(0, -4px, 0) scaleY(1.02);
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}
.swiper-box {
  position: relative;
  max-width: 1100px;
  width: 100%;
  border: 1px solid #5c273b;
  .header {
    position: relative;
    width: 100%;
    background: #c0de36;
    z-index: 5000;
    border-bottom: 1px solid #5c273b;
    height: 100px;
    box-sizing: content-box;
    @media screen and (max-width: 750px) {
      height: get_vw(100px);
    }
    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("https://website.xdcdn.net/poster/1/2thMegaGame/zIiCSdUl.png");
      width: 58px;
      height: 13px;
      bottom: -13px;
      left: 155px;
      @media screen and (max-width: 1440px) {
        left: 55px;
      }
      @media screen and (max-width: 750px) {
        width: get_vw(58px);
        height: get_vw(13px);
        bottom: get_vw(-13px);
        left: get_vw(55px);
      }
    }
    .btn-can-hover {
      cursor: pointer;
      &::after {
        content: "";
        margin-left: 5%;
        top: 38%;
        display: inline-block;
        width: 31px;
        height: 18px;
        @media screen and (max-width: 1440px) {
          width: 22px;
          height: 11px;
          background-size: contain;
          background-position-x: center;
          background-repeat: no-repeat;
        }
        @media screen and (max-width: 750px) {
          width: get_vw(31px);
          height: get_vw(18px);
          background-size: contain;
          background-position-x: center;
          background-repeat: no-repeat;
        }
        background: url("https://website.xdcdn.net/poster/1/2thMegaGame/vector.svg");
        transform: rotate(90deg);
        animation-iteration-count: infinite;
        animation-name: bounce;
        transform-origin: center bottom;
        animation-duration: 3s;
        animation-fill-mode: both;
      }
      &:hover {
        &::after {
          animation-play-state: paused;
          transform: translateZ(0);
          transform: translate3d(0, 0, 0) scaleY(1);
        }
        .select-box {
          max-height: 600px;
          border-bottom: 1px solid #5c273b;
        }
      }
      .select-box {
        position: absolute;
        margin-top: 1px;
        top: 100px;
        background: #eeff7d;
        border-left: 1px solid #5c273b;
        border-right: 1px solid #5c273b;
        width: 550px;
        @media screen and (max-width: 1440px) {
          width: 350px;
        }
        @media screen and (max-width: 750px) {
          top: get_vw(100px);
          width: 50%;
          border-left: none;
          left: 0.075vw;
        }
        max-height: 0;
        transition: max-height 0.3s ease;
        z-index: -1;
        overflow: hidden;
        .li-content {
          margin: 34px 76px 25px 130px;
          @media screen and (max-width: 1440px) {
            margin: 34px 20px 25px 30px;
          }
          @media screen and (max-width: 750px) {
            margin-top: get_vw(34px);
            margin-right: get_vw(20px);
            margin-bottom: get_vw(25px);
            margin-left: get_vw(30px);
          }
          li {
            cursor: pointer;
            width: 100%;
            color: #5c273b;
            height: 27px;
            margin-bottom: 20px;
            font-size: 22px;
            line-height: 27px;
            @media screen and (max-width: 1440px) {
              font-size: 22px;
              line-height: 27px;
              height: 27px;
              margin-bottom: 20px;
            }
            @media screen and (max-width: 750px) {
              font-size: get_vw(22px);
              line-height: get_vw(27px);
              height: get_vw(27px);
              margin-bottom: get_vw(20px);
            }
            &::before {
              content: "";
              display: inline-block;
              width: 16px;
              height: 16px;
              border: 2px solid #5c273b;
              border-radius: 8px;
              margin-right: 18px;
              @media screen and (max-width: 1440px) {
                width: 16px;
                height: 16px;
                margin-right: 18px;
              }
              @media screen and (max-width: 750px) {
                width: get_vw(16px);
                height: get_vw(16px);
                margin-right: get_vw(18px);
              }
            }
          }
          .li-select {
            &::before {
              background: #5c273b;
            }
          }
        }
      }
    }
    .btn {
      background-position-x: center;
      width: 50%;
      height: 100px;
      background: #eeff7d;
      border-right: 1px solid #5c273b;
      @media screen and (max-width: 750px) {
        height: get_vw(100px);
        background-size: cover;
      }
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      .title {
        font-size: 40px;
        @media screen and (max-width: 1440px) {
          font-size: 35px;
        }
        @media screen and (max-width: 750px) {
          font-size: get_vw(40px);
        }
        font-weight: bold;
        font-family: "Noto Sans SC";
        color: #5c273b;
      }
    }
  }
  .content {
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 687px;
    @media screen and (max-width: 1440px) {
      height: 475px;
    }
    @media screen and (max-width: 750px) {
      height: get_vw(475px);
    }
    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 10%;
      height: 590px;
      @media screen and (max-width: 1440px) {
        height: 375px;
      }
      @media screen and (max-width: 750px) {
        height: get_vw(375px);
      }
      z-index: 100;
      background: linear-gradient(
        270deg,
        rgba(92, 39, 77, 0) 9.44%,
        rgba(36, 31, 51, 0.78) 102.18%
      );
      background-blend-mode: multiply;
      mix-blend-mode: multiply;
      opacity: 0.85;
    }

    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0px;
      right: 0px;
      width: 10%;
      height: 590px;
      @media screen and (max-width: 1440px) {
        height: 375px;
      }
      @media screen and (max-width: 750px) {
        height: get_vw(375px);
      }
      z-index: 100;
      background: linear-gradient(
        270deg,
        rgba(92, 39, 77, 0) 9.44%,
        rgba(36, 31, 51, 0.78) 102.18%
      );
      background-blend-mode: multiply;
      mix-blend-mode: multiply;
      opacity: 0.85;
      transform: rotate(-180deg);
    }
    img {
      width: 100%;
      height: 590px;
      @media screen and (max-width: 1440px) {
        height: 375px;
      }
      @media screen and (max-width: 750px) {
        height: get_vw(375px);
      }
      position: absolute;
      top: 0;
    }

    .swiper-button-next {
      bottom: 28px;
      right: 2%;
      top: 40%;
      z-index: 2000;
      &::after {
        color: #eeff7d;
        content: "";
        display: inline-block;
        background: url("https://website.xdcdn.net/poster/1/2thMegaGame/mobile/right.svg");
        width: 90px;
        height: 40px;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2000;
        @media screen and (max-width: 750px) {
          width: get_vw(90px);
          height: get_vw(40px);
        }
      }
    }
    .swiper-button-prev {
      bottom: 28px;
      left: 2%;
      top: 40%;
      z-index: 2000;
      &::after {
        color: #eeff7d;
        content: "";
        display: inline-block;
        background: url("https://website.xdcdn.net/poster/1/2thMegaGame/mobile/left.svg");
        width: 90px;
        height: 40px;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2000;
        @media screen and (max-width: 750px) {
          width: get_vw(90px);
          height: get_vw(40px);
        }
      }
    }
  }
}

.swiper-pagination {
  width: 100%;
  height: 20px;
  margin-top: 40px;
  @media screen and (max-width: 750px) {
    height: get_vw(20px);
    margin-top: get_vw(40px);
  }
  /deep/ .swiper-pagination-bullet {
    margin: 0 10px;
    width: 20px !important;
    height: 20px !important;
    background: transparent;
    border: 2px solid #5c273b;
    opacity: 1 !important;
    @media screen and (max-width: 750px) {
      height: get_vw(20px) !important;
      width: get_vw(20px) !important;
      margin-left: get_vw(10px);
      margin-right: get_vw(10px);
    }
  }
  /deep/ .swiper-pagination-bullet-active {
    background: #5c273b;
  }
}

.footer {
  width: 100%;
  height: 97px;
  background-color: #c0de36;
  border-top: 1px solid #5c273b;
  display: flex;
  position: absolute;
  bottom: 0px;
  z-index: 1;
  @media screen and (max-width: 1440px) {
    height: 100px;
  }
  @media screen and (max-width: 750px) {
    height: get_vw(100px);
  }
  .left {
    width: 550px;
    height: 100%;
    // border-right: 1px solid #5c273b;
    padding: 10px 17px;
    display: flex;
    flex-direction: column;
    background: #eeff7d;
    @media screen and (max-width: 1440px) {
      width: 580px;
      border-right: none;
    }
    @media screen and (max-width: 750px) {
      width: get_vw(580px);
      padding-top: get_vw(5px);
      padding-bottom: get_vw(10px);
      padding-left: get_vw(17px);
      padding-right: get_vw(17px);
    }
    .name {
      color: #5c273b;
      font-size: 30px;
      font-weight: bold;
      font-family: "Noto Sans SC";
      @media screen and (max-width: 1440px) {
        font-size: 30px;
      }
      @media screen and (max-width: 750px) {
        font-size: get_vw(30px);
      }
    }
    .type {
      display: flex;
      align-items: center;
      @media screen and (max-width: 750px) {
        position: absolute;
        bottom: 15%;
      }
      .item {
        background: #5c273b;
        color: #eeff7d;
        font-size: 12px;
        font-family: "Noto Sans SC";
        margin-right: 7px;
        padding: 4px 12px;
        border-radius: 30px;
        @media screen and (max-width: 750px) {
          line-height: 18px;
          padding-top: get_vw(2px);
          padding-bottom: get_vw(2px);
          padding-left: get_vw(12px);
          padding-right: get_vw(12px);
          margin-right: get_vw(7px);
          border-radius: get_vw(30px);
        }
      }
    }
  }
  .center {
    width: 100% !important;
    .introduce {
      color: #5c273b;
      font-size: 20px;
      font-family: "Noto Sans SC";
      text-align: center;
      line-height: 80px;
      @media screen and (max-width: 1440px) {
        font-size: 20px;
        line-height: 80px;
      }
      @media screen and (max-width: 750px) {
        font-size: get_vw(20px);
        line-height: get_vw(80px);
      }
    }
  }
  .label {
    width: 550px;
    height: 100px;
    margin-top: -12px;
    color: #5c273b;
    font-size: 50px;
    font-weight: bold;
    font-family: "Noto Sans SC";
    display: flex;
    padding-top: 22px;
    justify-content: center;

    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("https://website.xdcdn.net/poster/1/2thMegaGame/zIkAkfeW.png");
      width: 58px;
      height: 13px;
      top: -13px;
      right: 155px;
      @media screen and (max-width: 1440px) {
        background-image: url("https://website.xdcdn.net/poster/1/2thMegaGame/zIiCSdUl.png");
        top: -13px;
        right: 55px;
        transform: rotate(-180deg);
      }
      @media screen and (max-width: 750px) {
        top: get_vw(-13px);
        width: get_vw(58px);
        right: get_vw(55px);
        height: get_vw(13px);
      }
    }

    @media screen and (max-width: 1440px) {
      font-size: 30px;
      padding-top: 0px;
      display: flex;
      align-items: center;
      width: 550px;
      height: 100px;
      margin-top: 0px;
      border-right: none;
      background-color: #eeff7d;
      border-bottom: 1px solid #5c273b;
    }
    @media screen and (max-width: 750px) {
      font-size: get_vw(30px);
      width: get_vw(550px);
      height: get_vw(100px);
    }
  }
}
</style>
